import React from 'react';

import { Box, Inline } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { Absolute, HeaderText } from '../../../ui';

import './AnimatedHeaderText.module.scss';

export type AnimatedHeaderTextProps = {
  headerText: string;
  inView?: boolean;
};

export default function AnimatedHeaderText({
  headerText,
  inView = false,
}: AnimatedHeaderTextProps) {
  return (
    <Absolute
      style={{
        position: 'absolute',
        opacity: inView ? 1 : 0,
        transform: [{ translateY: inView ? 0 : 80 }],
      }}
      styleName="animated-header-text"
      testID={`header_service_tiles_animated_header_text_item_${(headerText || '').toLowerCase()}_in_view_${inView}`}
    >
      <Inline paddingX={16} paddingBottom={4} paddingTop={12}>
        <Box>
          <HeaderText
            color={BrandColor.FloraDark}
            level={3}
          >
            {headerText}
          </HeaderText>
        </Box>
        <Box><HeaderText level={3}>&nbsp;hair starts here</HeaderText></Box>
      </Inline>
    </Absolute>
  );
}
